import { useContext, useMemo } from "react";
import Loading from "../../../../../../commons/Loading/Loading";
import Button from "../../../../../../designSystem/Button/Button";
import { CompaniesMapListProps } from "./CompaniesMapList.types";
import { SearchCompaniesOnMapContext } from "../../../SearchCompaniesOnMap/SearchCompaniesOnMap.context";
import CompaniesListItem from "../../../DashboardCompanies/DashboardCompaniesTable/CompaniesListItem/CompaniesListItem";

export default ({ companies, isLoading, selectedCompany, chooseCompany, removeGeoFilters }: CompaniesMapListProps) => {

  const { mapRef } = useContext(SearchCompaniesOnMapContext)

  const currentZoom = mapRef.current?.getZoom()

  const isFullCountry = useMemo(() => currentZoom === 5, [currentZoom])

  if (isLoading) return <Loading />

  return (
    <>
      {(companies && companies.results.length > 0)
        ?
        companies?.results.map((company, index) => (
          <CompaniesListItem
            key={index}
            {...{ company }}
            onClick={() => {
              chooseCompany(company)
            }}
            style={{
              backgroundColor: company.id === selectedCompany?.id ? '#00000010' : undefined
            }}
          />
        ))
        :
        !isFullCountry
          ?
          <>
            <h1>Aucune entreprise ne correspond à vos critères</h1>
            <Button
              style={{
                alignSelf: 'unset',
                textAlign: 'center',
                borderRadius: 6,
                marginLeft: 'var(--spacing-s)',
                marginBottom: 'var(--spacing-s)',
                width: 'calc(100% - var(--spacing-s) * 2)',
                paddingLeft: 0,
                paddingRight: 0,
              }}
              onClick={removeGeoFilters}
            >
              Voir dans toute la france
            </Button>
          </>
          :
          <h1>Aucune entreprise trouvée</h1>
      }
    </>
  )
}